<div *ngIf="varietyObservationObs$ | async as resp">
  <!-- Title and subtitle -->
  <div class="body" style="margin-bottom: -30px" *ngIf="resp.data.is_original">
    <span
      matRipple
      (click)="fnItem(resp.data.variety_id, resp.data.is_original)"
      style="font-size: 32px; font-weight: 400"
      >{{ resp.data.variety_name }}
      <mat-icon color="primary" style="margin-top: 16px; margin-left: 10px"
        >verified_user</mat-icon
      >
    </span>
    <br />
    <span
      style="
        font-size: 24px;
        font-weight: 300;
        font-style: italic;
        margin-top: -8px;
      "
      *ngIf="resp.data.synonyms"
    >
      {{ resp.data.synonyms }}
    </span>
  </div>

  <div
    class="body"
    style="margin-bottom: -30px"
    *ngIf="!resp.data.is_original"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <span style="font-size: 32px; font-weight: 400"
        >{{ resp.data.variety_name }}
        <mat-icon
          matRipple
          (click)="fnItem(resp.data.variety_id, resp.data.is_original)"
          color="primary"
          style="margin-top: 16px; margin-left: 10px"
          >info_outline</mat-icon
        >
      </span>
    </div>
    <div>
      <br />
      <span
        style="font-size: 20px; font-weight: 200; font-style: italic"
        *ngIf="resp.data.synonyms"
      >
        {{ resp.data.synonyms }}
      </span>
    </div>
  </div>

  <!-- Gallery and map -->

  <div style="max-width: 1170px; margin: 0px auto; padding: 15px">
    <div style="width: 100%">
      <mat-card style="padding: 0px">
        <div fxLayout="row">
          <div fxFlex="60" style="border-right: 1px solid #ddd; padding: 15px">
            <mat-card-content style="margin-bottom: 0px">
              <app-slider-image
                *ngIf="images.length > 0"
                [images]="images"
                [indexImg]="indexImg"
              ></app-slider-image>
            </mat-card-content>
          </div>

          <div fxFlex="40" style="padding: 12px">
            <mat-card-header>
              <mat-icon
                mat-card-avatar
                [ngStyle]="{ color: '#8b2f00' }"
                style="font-size: 40px"
                >account_circle</mat-icon
              >
              <mat-card-title>
                {{ resp.data.username }}
              </mat-card-title>

              <mat-card-subtitle style="flex: display; align-items: center">
                <span
                  style="color: #1e88e5; cursor: pointer"
                  (click)="
                    fnGoToView(
                      'observaciones',
                      resp.data.user_id,
                      resp.data.username
                    )
                  "
                >
                  <img
                    style="
                      height: 14px;
                      width: 14px;
                      object-fit: cover;
                      color: #bbb;
                      margin-bottom: -2px;
                    "
                    src="https://wikipapa.org/images/favpng_binoculars.png"
                  />

                  {{ resp.data.user_observation_count }} Observaciones
                </span>
              </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content
              style="padding-top: 15px; border-top: 1px solid #ddd"
            >
              <span style="font-weight: bold">Observado el:</span>
              <span> {{ resp.data.observation_date?.substring(0, 10) }}</span>
              <br /><br />
              <app-template-map
                [coordinate_list]="[
                  {
                    latitude: resp.data.latitude,
                    longitude: resp.data.longitude,
                    location: resp.data.location
                  }
                ]"
                [height_value]="'280px'"
                [icon]="'place'"
                [zoom]="8"
              ></app-template-map>
            </mat-card-content>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <!-- Activities-->
  <br />
  <div
    style="
      max-width: 1170px;
      margin: 0px auto;
      padding: 15px;
      padding-bottom: 0px;
    "
  >
    <span fxLayout="row" style="font-size: 32px; font-weight: 400">
      Actividad</span
    >
  </div>

  <div
    class="body"
    fxLayout="row"
    *ngIf="varObvActivitiesObs | async as option_data_list"
  >
    <div fxFlex="60">
      <div *ngFor="let value_item of option_data_list.data" fxLayout="row">
        <div>
          <mat-icon mat-card-avatar style="font-size: 50px"
            >account_circle</mat-icon
          >
        </div>
        <mat-card style="margin: 0px 0px 10px 30px; width: 600px">
          <div style="margin-bottom: 10px">
            <span style="font-weight: 700">{{ value_item.user.username }}</span>

            <span>
              {{ value_item.activity_description }}
            </span>

            <span style="font-weight: 700; float: right">
              {{ value_item.updated_at?.substring(10, 0) }}
            </span>
          </div>

          <mat-divider></mat-divider>

          <div fxLayout="row" style="margin-top: 25px">
            <div style="width: 60px">
              <img
                *ngIf="value_item.variety.image_url"
                style="height: 54px; width: 54px; object-fit: cover"
                src="{{ value_item.variety.image_url }}"
              />

              <img
                *ngIf="!value_item.variety.image_url"
                style="height: 54px; width: 54px; object-fit: cover"
                src="https://wikipapa.org/images/img-no-disponible.jpg"
              />
            </div>
            <div style="width: 500px">
              <b> {{ value_item.variety.variety_name }} </b>
              <br />
              <i> {{ value_item.variety.synonyms }} </i>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Last observation -->
  <br />
  <div
    style="background-color: #eee; margin: 0px auto; padding: 15px; bottom: 0px"
    *ngIf="varObvLastObs | async as varObsData"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      style="width: 1170px; margin: 20px auto"
    >
      <div style="width: 50%">
        <span style="font-size: 30px">
          Más de
          <b>
            {{ resp.data.username }}
          </b>
        </span>
      </div>
      <div style="width: 50%; text-align: right; margin: auto">
        <span
          style="color: #1e88e5; cursor: pointer"
          (click)="
            fnGoToView('observaciones', resp.data.user_id, resp.data.username)
          "
        >
          Ver todos
        </span>
      </div>
    </div>

    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      style="width: 1170px; margin: 20px auto"
    >
      <div *ngFor="let varObsData_item of varObsData.data">
        <mat-card
          class="mat-elevation-z6"
          matRipple
          (click)="fnGoObs(varObsData_item.variety_observation_id)"
          style="margin-bottom: 10px; height: 260px; width: 180px; padding: 0px"
        >
          <img
            src="{{ varObsData_item.observation_image_url }}"
            style="
              height: 180px;
              width: 100%;
              object-fit: cover;
              margin: 0px 0px -6.5px 0px;
            "
          />
          <div style="height: 80px; background-color: #fff; padding: 8px">
            <span style="font-size: 12px; font-weight: 500">
              {{ varObsData_item.variety_name }}
            </span>
            <br />
            <span style="font-style: italic">
              {{ varObsData_item.species_name }}
            </span>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
